$(function () {
    // Reusable setup function code for the validation input field of search page, move here code from SXAHeader.cshtml
    // Global Search input validation........
    let minCharCount = 3;
    const allowedRegex = /^[a-zA-Z0-9\sñáéíóúü¿¡]*$/;
    const srchTerm = 'search-term';
    const validMessage = 'validationMessage';
    const mobSearchTerm = 'mobile-search-term';
    const mobValidationMessage = 'mobileValidationMessage';
    function setupSearchValidation(inputId, messageId, minLengthErrorMsg, specialCharErrorMessage, searchValidationMessage, maxLengthErrorMsg) {
        const inputEl = document.getElementById(inputId);
        const msgEl = document.getElementById(messageId);
        if (!inputEl || !msgEl) return;
        // Input typing handler
        inputEl.addEventListener('input', () => {
            if (!allowedRegex.test(inputEl.value)) {
                msgEl.textContent = specialCharErrorMessage;
                msgEl.style.display = 'block';
                // Strip invalid characters
                inputEl.value = inputEl.value.replace(/[^a-zA-Z0-9\sñáéíóúü¿¡]/g, '');
            }
            else if (inputEl.value.length < minCharCount) {
                msgEl.style.display = 'block';
                msgEl.textContent = minLengthErrorMsg;
            } else if (inputEl.value.trim().length === 0 && inputEl.value.length > 0) {
                msgEl.textContent = searchValidationMessage;
                msgEl.style.display = 'block';
            } else if (inputEl.value.length >= 250) {
                msgEl.textContent = maxLengthErrorMsg;
                msgEl.style.display = 'block';
            }
            else {
                msgEl.style.display = 'none';
            }
        });
        // Prevent search on Enter if less than 3 chars
        inputEl.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' && inputEl.value.trim().length < minCharCount) {
                e.preventDefault();
                msgEl.textContent = minLengthErrorMsg;
                msgEl.style.display = 'block';
            }
            else if (e.key === 'Enter' && !allowedRegex.test(inputEl.value)) {
                e.preventDefault();
                msgEl.textContent = specialCharErrorMessage;
                msgEl.style.display = 'block';

            }
            else if (inputEl.value.trim().length === 0 && inputEl.value.length > 0) {
                msgEl.textContent = searchValidationMessage;
                msgEl.style.display = 'block';
            } else if (inputEl.value.length >= 250) {
                msgEl.textContent = maxLengthErrorMsg;
                msgEl.style.display = 'block';
            }
        });
        // Paste handler
        inputEl.addEventListener('paste', (e) => {
            const pasteData = (e.clipboardData || window.clipboardData).getData('text');
            if (!allowedRegex.test(pasteData)) {
                e.preventDefault();
                msgEl.textContent = pasteError;
                msgEl.style.display = 'block';
            }
        });
    }
    // Apply to both desktop and mobile inputs
    setupSearchValidation(srchTerm, validMessage, minLengthErrorMsg, specialCharErrorMessage, searchValidationMessage, maxLengthErrorMsg);
    setupSearchValidation(mobSearchTerm, mobValidationMessage, minLengthErrorMsg, specialCharErrorMessage, searchValidationMessage, maxLengthErrorMsg);
    /////////////////////////
    // Cookies Policy related code move here from SXAStandardLayout.cshtml
    var consentGrant = toGtmSignals({ necessary: true, preferences: true, statistics: true, marketing: true });
    var consentDeny = toGtmSignals({ necessary: true, preferences: false, statistics: false, marketing: false });
    function toGtmSignals(check) {
        function checks(ischecked) { return ischecked ? 'granted' : 'denied'; }
        return {
            ad_storage: checks(check.marketing),
            ad_user_data: checks(check.marketing),
            ad_personalization: checks(check.marketing),
            analytics_storage: checks(check.statistics),
            functionality_storage: checks(check.preferences),
            security_storage: checks(check.necessary),
            wait_for_update: 500
        };
    }
    function getCookieValue(name) {
        var safe = name.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
        var m = document.cookie.match(new RegExp('(?:^|; )' + safe + '=([^;]*)'));
        return m ? decodeURIComponent(m[1]) : null;
    }
    var checkPrivacyCookie = getCookieValue('Privacy_Cookie');
    $(function () {
        if (navigator.globalPrivacyControl == true) {
            $('#privacyBar').css('display', 'none');
            gtag('consent', 'default', consentDeny);
        } else {
            if (checkPrivacyCookie) {
                $('#privacyBar').css('display', 'none');
                var obj = JSON.parse(checkPrivacyCookie);
                var booleans = {
                    necessary: !!obj.necessary,
                    preferences: !!obj.preferences,
                    statistics: !!obj.statistics,
                    marketing: !!obj.marketing
                };
                $(".cookie-item[name='Necessary']").prop("checked", booleans.necessary).prop("disabled", true);
                $(".cookie-item[name='Preferences']").prop("checked", booleans.preferences);
                $(".cookie-item[name='Statistics']").prop("checked", booleans.statistics);
                $(".cookie-item[name='Marketing']").prop("checked", booleans.marketing);
                gtag('consent', 'default', toGtmSignals(booleans));
                return;
            } else {
                $('#privacyBar').css('display', 'block');
                if (gdprCheck == "True") {
                    gtag('consent', 'default', consentDeny);
                } else {
                    gtag('consent', 'default', consentGrant);
                }
            }
        }
    });
    /////////////////////////////////////
    $(document).foundation();
    $('.map-img[data-index="1"]').addClass('current');
    document.createElement("picture");

    /*** Image Lazing Loading Starts ***/
    var images = document.querySelectorAll('img[data-src]');
    var observer = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
                return;
            } else {
                var img = entry.target;
                img.src = img.getAttribute("data-src");
                observer.unobserve(img);
            }
        });
    });
    images.forEach(function (img) {
        observer.observe(img);
    });
    /*** Image Lazing Loading Ends ***/
    // Desktop and mobile add or remove class
    $(window).on(
        "changed.zf.mediaquery resize.zf.mediaquery load.zf.mediaquery",
        function () {
            if (
                Foundation.MediaQuery.current == "small" ||
                Foundation.MediaQuery.current == "medium"
            ) {
                $("#mainnav > li").each(function () {
                    if ($(this).children("ul").length) {
                        $(this).addClass("has-children");
                        $(this).children("ul").removeClass("is-dropdown-submenu");
                    }
                });
            } else {
                $("body,html").removeClass("overflow-hidden");
                $("#nav-icon2").removeClass("open");
                $("#mainnav > li.has-children ul").removeAttr("style");
                $("#mainnav > li").each(function () {
                    if ($(this).children("ul").length) {
                        $(this).removeClass("has-children");
                        $(this).children("ul").addClass("is-dropdown-submenu");
                    }
                });
            }
        }
    );
    //Previously open nav close
    $("#nav-icon2").click(function () {
        setTimeout(function () {
            if ($("#mainnav > li.has-children").find("ul").is(":visible")) {
                $("#mainnav > li.has-children")
                    .removeClass("active")
                    .find("ul")
                    .slideUp();
            }
            $(".language-dropdown .selectedLang.active").trigger("click");
        }, 500);
    });
    $(".close-hamberger").click(function () {
        $("#nav-icon2").trigger("click");
    });
    //Desktop MouseHover add remove class
    $("#mainnav > li")
        .mouseenter(function () {
            $(".search-dropdown").slideUp();
            $("header .search-toggle").removeClass("search-open");
            $(".search-dropdown").attr("aria-hidden", true);
            $(".search-toggle").attr("aria-expanded", false);
            $(this).addClass("is-active");
        })
        .mouseleave(function () {
            $(this).removeClass("is-active");
        });
    //Mobile Accordian nav
    $(document).on("click", "#mainnav > li .arrow", function () {
        $(this).next("ul").slideToggle();
        $(this).parent("li").siblings().find("ul").slideUp();
        $(this).parent().toggleClass("active").siblings().removeClass("active");
        if ($(".lan-dropdown").is(":visible")) {
            $(".lan-dropdown").slideUp();
            $(".selectedLang").removeClass("active");
        }
        if ($(this).attr("aria-expanded") == "false") {
            $(this).attr("aria-expanded", true);
            $(this).next("ul").attr("aria-hidden", false);
        } else {
            $(this).attr("aria-expanded", false);
            $(this).next("ul").attr("aria-hidden", true);
        }
    });
    //Mobile Acive Nav scroll to top
    $("#mainnav").on("click", "li.has-children", function () {
        $(this).each(function () {
            $panel = $(this);
            $("#mainnav").animate(
                {
                    scrollTop: $panel.position().top,
                },
                500
            );
        });
    });
    $("#mainnav").on("click", ".is-accordion-submenu-parent > a", function () {
        $(this).each(function () {
            $panel = $(this).closest("li");
            $("#mainnav").animate(
                {
                    scrollTop: $panel.position().top,
                },
                500
            );
        });
    });
    /*Search*/
    $(".search, .search input").on("click", function (event) {
        event.stopPropagation();
    });
    $(".search").on("click", function (event) {
        $(this).toggleClass("active");
        $(".search input").focus();
    });
    $("body,html").on("click", function () {
        $(".search").removeClass("active");
    });
    /*Search Ends*/
    /*language toggle*/
    $(".langSelected").on("click", function (event) {
        event.preventDefault();
        var isoCode = $(this).attr("iso-code").toUpperCase();
        if (isoCode != null && isoCode != undefined) {
            $(this).parent().parent().parent().find("a.selectedLang").text(isoCode);
        }
        $(this)
            .parent()
            .parent()
            .find("a.langSelected")
            .removeClass("showCheckmark");
        $(this).addClass("showCheckmark");
    });
    //header footer mobile menu
    $(".menu-mob > li:has(ul) > a").after(`<span>
    <svg class="arrow-icon-down" width="17" height="11" viewBox="0 0 17 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.83353 10.7917C9.7549 9.92116 12.8589 6.99319 13.0024 6.85925C13.1723 6.70299 13.4253 6.46861 13.6028 6.29375C14.3391 5.56083 15.0113 4.76465 15.6872 4.21775C16.0535 3.92012 16.5595 3.62249 16.8351 3.24672C17.2392 2.6961 16.8162 2.52497 16.4688 2.15292C16.3782 2.05619 16.2687 1.93342 16.1856 1.82925C16.0535 1.66183 15.7778 1.18189 15.6268 1.10004C15.4304 0.995872 15.234 1.10004 15.0603 1.20422C13.9426 2.22733 12.8815 3.46251 11.7978 4.43354C11.6883 4.53399 11.4315 4.74977 11.3031 4.86883L9.33393 6.85925C9.10227 7.22622 8.83353 7.4456 8.6376 7.22622L6.16004 4.70141C6.06564 4.59723 5.78999 4.2996 5.78999 4.2996C5.13672 3.59272 4.48723 2.89328 3.9699 2.27198C3.66781 1.91109 3.36572 1.41256 2.98433 1.14097C2.42547 0.742883 2.25177 1.15957 1.87416 1.50185C1.77598 1.59114 1.65137 1.69903 1.54563 1.78088C1.37571 1.91109 0.888592 2.18268 0.805517 2.3315C0.699785 2.52496 0.805517 2.71842 0.911247 2.88956C1.9459 3.99081 3.07496 5.1367 4.02276 6.2305L4.52121 6.77368L8.32753 10.7731C8.46347 10.9145 8.68626 10.9219 8.82976 10.788L8.83353 10.7917Z" fill="#db0007"/>
    </svg>
    <svg class="arrow-icon-right" width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.90697 8.93078C9.03639 8.023 6.10842 4.96482 5.97449 4.82344C5.81823 4.65602 5.58384 4.40676 5.40898 4.2319C4.67606 3.50641 3.87989 2.84418 3.33299 2.17823C3.03535 1.81735 2.73772 1.31881 2.36196 1.04722C1.81134 0.649134 1.6402 1.06582 1.26816 1.4081C1.17143 1.49739 1.04865 1.60528 0.944482 1.68713C0.777063 1.81735 0.297127 2.08894 0.215278 2.23775C0.111106 2.43121 0.215279 2.62468 0.319451 2.79581C1.34257 3.89706 2.57774 4.9425 3.54877 6.01026C3.64922 6.11815 3.86501 6.37114 3.98406 6.49763L5.97449 8.43777C6.34145 8.66601 6.56084 8.93078 6.34145 9.12382L3.81664 11.5648C3.71247 11.6578 3.41484 11.9294 3.41484 11.9294C2.70796 12.5731 2.00852 13.213 1.38721 13.7227C1.02633 14.0203 0.527794 14.3179 0.256203 14.6937C-0.141882 15.2443 0.274806 15.4155 0.617084 15.7875C0.706374 15.8842 0.814266 16.007 0.896115 16.1112C1.02633 16.2786 1.29792 16.7585 1.44674 16.8404C1.6402 16.9446 1.83366 16.8404 2.0048 16.7362C3.10604 15.7168 4.25193 14.6044 5.34573 13.6706L5.88891 13.1795L9.88836 9.42932C10.0297 9.29538 10.0372 9.07588 9.90325 8.9345L9.90697 8.93078Z" fill="#000000"/>
    </svg></span>`);
    $('.menu-icon, .menu-icon-mob').on('click', function () {
        $('header').toggleClass('active-mob-menu');
    });
    function setupAccordion() {
        var screenWidth = $(window).width();
        if (screenWidth <= 1023) {
            $(".menu-desk").hide();
            $(".menu-mob").show();
            // Hide all items and show the first one
            $('.menu-mob>li>ul').hide();
            $('.menu-mob>li').removeClass('active-menu');
            // Unbind previous click handlers to avoid duplicates
            $('.menu-mob>li>span').off('click').on('click', function () {
                var item = $(this).next('.menu-mob>li>ul');
                if (item.is(':visible')) {
                    item.slideUp();
                    $(this).parent().removeClass('active-menu');
                } else {
                    $('.menu-mob>li>ul').slideUp();
                    $('.menu-mob>li').removeClass('active-menu');
                    item.slideDown();
                    $(this).parent().addClass('active-menu');
                }
            });

            $('.footer-accordion-item').hide();
            $('.footer-accordion-item').first().show();
            $('.footer-accordion-head').removeClass('active-item');
            $('.footer-accordion-head').first().addClass('active-item');
            // Unbind previous click handlers to avoid duplicates
            $('.footer-accordion-head').off('click').on('click', function () {
                var item = $(this).next('.footer-accordion-item');
                if (item.is(':visible')) {
                    item.slideUp();
                    $(this).removeClass('active-item');
                } else {
                    $('.footer-accordion-item').slideUp();
                    $('.footer-accordion-head').removeClass('active-item');
                    item.slideDown();
                    $(this).addClass('active-item');
                }
            });
        } else {
            // For larger screens, show all items and remove active class
            $(".menu-desk").show();
            $(".menu-mob").hide();
            $('.footer-accordion-item').show();
            $('.footer-accordion-head').removeClass('active-item');
            $('.footer-accordion-head').off('click'); // Remove click handlers
        }
    }
    // Initial setup
    setupAccordion();
    // Re-setup on window resize
    $(window).resize(function () {
        setupAccordion();
    });
    // sticky nav Start
    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;
    var navbarHeight = $("header").outerHeight();
    const myheader = document.querySelector('header');
    $("main").css("padding-top", navbarHeight);
    $(window).scroll(function (event) {
        didScroll = true;
    });
    setInterval(function () {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);
    function hasScrolled() {
        var st = $(this).scrollTop();
        // Make scroll more than delta
        if (Math.abs(lastScrollTop - st) <= delta) return;
        // If scrolled down and past the navbar, add class .nav-up.
        if (st > lastScrollTop && st > navbarHeight) {
            // Scroll Down
            $("header").removeClass("nav-down").addClass("nav-up");
            myheader.style.top = '-100px';
            if ($(".hero-block-componant, .timeline-wrapper-outer, .donation-main-form").hasClass("trans-bg")) {
                $("header").removeClass("trans-header");
            }
        } else if (st <= navbarHeight) {
            $("header").removeClass("nav-down").removeClass("nav-up");
            myheader.style.top = '0';
            if ($(".hero-block-componant, .timeline-wrapper-outer, .donation-main-form").hasClass("trans-bg")) {
                $("header").addClass("trans-header");
            }
        } else if (st + $(window).height() < $(document).height()) {
            $("header").removeClass("nav-up").addClass("nav-down");
            myheader.style.top = '0';
            if ($(".hero-block-componant, .timeline-wrapper-outer, .donation-main-form").hasClass("trans-bg")) {
                $("header").addClass("trans-header");
            }
        }
        lastScrollTop = st;
    }
    // transparent header class need to pass here
    if ($(".hero-block-componant, .timeline-wrapper-outer, .donation-main-form").hasClass("trans-bg")) {
        $("header").addClass("trans-header");
    } else {
        $("header").removeClass("trans-header");
    }
    // remove padding-top form main tag with trans-header
    if ($("header").hasClass("trans-header")) {
        $("main").css("padding-top", 0);
    }
    //donate page identity class in header
    if ($("section").hasClass("donation-main-form")) {
        $("header").addClass("donate-header");
    } else {
        $("header").removeClass("donate-header");
    }
    // sticky nav ends
    /*Hamburger menu*/
    $("#nav-icon2").click(function () {
        $(this).attr("aria-expanded", true);
        $("nav").show("slide", { direction: "right" }, 500, function () {
            $(".close-hamberger").addClass("open");
        });
        $('<div class="nav-backdrop" tabindex="-1"></div>').insertBefore("nav");
        $("html,body").addClass("overflow-hidden");
        $("nav").attr("aria-hidden", "false");
        $(".title-bar").attr({ tabindex: -1, "aria-hidden": true });
        $("main").attr({ tabindex: -1, "aria-hidden": true });
    });
    $(".close-hamberger").click(function (e) {
        $("nav").hide("slide", { direction: "right" }, 500, function () {
            $(".close-hamberger").removeClass("open");
            $("#nav-icon2").focus();
        });
        $(".nav-backdrop").remove();
        $("html,body").removeClass("overflow-hidden");
        $(".nav-icon").attr("aria-expanded", false);
        $("nav").attr("aria-hidden", "true");
        $(".title-bar").removeAttr("tabindex aria-hidden");
        $("main").removeAttr("tabindex aria-hidden");
    });
    // Image Gallery script Start
    $("#example-tabs").on("change.zf.tabs", function () {
        $(".slider-for").slick("refresh");
        $(".slider-nav").slick("refresh");
    });
    var numSlick = 0;
    $(".slider-for").each(function () {
        numSlick++;
        $(this)
            .addClass("slider-" + numSlick)
            .on({
                beforeChange: function (
                    event,
                    slick,
                    current_slide_index,
                    next_slide_index
                ) {
                    var className = $(this).next().attr("class");
                    var newclassName = className.split(/\s/).join(".");
                    $("." + newclassName + " .slick-slide").removeClass(
                        "slick-main-active"
                    );
                    $(
                        "." +
                        newclassName +
                        " .slick-slide[data-slick-index=" +
                        next_slide_index +
                        "]"
                    ).addClass("slick-main-active");
                },
            })
            .slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                fade: true,
                adaptiveHeight: false,
                asNavFor: ".slider-nav.slider-" + numSlick,
            });
    });
    numSlick = 0;
    $(".slider-nav").each(function () {
        numSlick++;
        $(this)
            .addClass("slider-" + numSlick)
            .slick({
                vertical: false,
                slidesToShow: 10,
                slidesToScroll: 1,
                asNavFor: ".slider-for.slider-" + numSlick,
                arrows: false,
                focusOnSelect: true,
                infinite: false,
                adaptiveHeight: false,
                responsive: [
                    {
                        breakpoint: 640,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1,
                            infinite: false,
                        },
                    },
                ],
            });
    });
    // Image Gallery script End
    $(document).on("keydown", ".slick-arrow", function (e) {
        if (e.keyCode == 27) {
            $(".tabs a[aria-selected=true]").focus();
        }
    });
    $(".language-dropdown .selectedLang").click(function () {
        $(this).toggleClass("active").next().slideToggle();
        if ($(".has-children ul").is(":visible")) {
            $(".has-children ul").slideUp();
            $(".has-children").removeClass("active");
        }
        return false;
    });
    $(".lan-dropdown a").click(function () {
        var dataVal = $(this).data("value");
        $(this)
            .parent()
            .addClass("selected")
            .siblings("li")
            .removeClass("selected");
        $(".language-dropdown .selectedLang").text(dataVal).removeClass("active");
        $(this).parents(".lan-dropdown").slideUp();
        return false;
    });
    /*Available media Begins*/
    $(".available-media .align-middle ul>li>a>span").each(function () {
        $(this).css({
            top: -$(this).height() - 10,
        });
    });
    //Horizontal file  gallery
    $(".horizontal-search-card-file").slick({
        slidesToShow: 4,
        //centerMode: true,
        prevArrow:
            '<div class="left-arrow"><button class="slick-prev" aria-label="Previous" type="button">Previous</button></div>',
        nextArrow:
            '<div class="right-arrow"><button class="slick-next" aria-label="Next" type="button">Next</button></div>',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 780,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                },
            },
        ],
    });

    $('.hero-clicktonext').click(function (e) {
        e.preventDefault(); // Prevent default jump
        const target = document.querySelector('#supportfamily');
        if (target) {
            target.scrollIntoView({ behavior: 'smooth' });
            history.pushState(null, null, '#supportfamily');
        }
    });

    // opening closing animation for mobile menu bar
    $(".menu-icon").click(function () {
        document.querySelector('#main-nav').style.cssText = "right: 0;";
    });

    $("#mob-search-togle").click(function () {
        document.querySelector('#main-nav').style.cssText = "right: -100%;";
    });

    $("#search-toggle-moble, .mob-closeOverlay").click(function () {
        const isVisible = document.querySelector('.search-box-mob').style.display === 'block';
        console.log('isVisible', isVisible);
        if (isVisible) {
            console.log('if')
            document.querySelector('.rmh-title-bar').style.display = 'block';
            document.querySelector('.mob-closeOverlay').style.display = 'none';
        }
        else {
            console.log('else')
            document.querySelector('.rmh-title-bar').style.display = 'none';
            document.querySelector('.mob-closeOverlay').style.display = 'block';
        }
    });

    //seach start
    $(".rmhc-search-btn").on("click", function (event) {
        var searchTerm = $("#search-term")[0].value || " ";
        const msgEl = document.getElementById(validMessage);
        msgEl.textContent = minLengthErrorMsg;
        if (searchTerm != undefined && searchTerm.trim() != "" && searchTerm.trim().length >= minCharCount && searchTerm.trim().length <= 250) {
            msgEl.style.display = 'none';
            window.open("/search?q=" + encodeURIComponent(searchTerm.trim()).replace(/%20/g, "+"), "_self");
            $(this).parents(".input-group").next(".error-msg").hide();
            $(this)
                .parents(".input-group")
                .children(".input-group-field")
                .removeAttr("aria-invalid aria-describedby");
        } else {
            msgEl.style.display = 'block';
            $(this)
                .parents(".input-group")
                .next(".error-msg")
                .css("display", "block");
            $(this).parents(".input-group").children(".input-group-field").attr({
                "aria-invalid": true,
                "aria-describedby": "searchError",
            });
            $("#search-term").focus();
        }
    });
    $(".rmhc-mobile-search-btn").on("click", function (event) {
        var searchTerm = $("#mobile-search-term")[0].value || " ";
        const msgEl = document.getElementById(mobValidationMessage);
        msgEl.textContent = minLengthErrorMsg;
        if (searchTerm != undefined && searchTerm.trim() != "" && searchTerm.trim().length >= minCharCount && searchTerm.trim().length <= 250) {
            msgEl.style.display = 'none';
            window.open("/search?q=" + encodeURIComponent(searchTerm.trim()).replace(/%20/g, "+"), "_self");
            $(this).parents(".input-group").next(".error-msg").hide();
            $(this)
                .parents(".input-group")
                .children(".input-group-field")
                .removeAttr("aria-invalid aria-describedby");
        } else {
            msgEl.style.display = 'block';
            $(this)
                .parents(".input-group")
                .next(".error-msg")
                .css("display", "block");
            $(this).parents(".input-group").children(".input-group-field").attr({
                "aria-invalid": true,
                "aria-describedby": "searchError-mobile",
            });
        }
    });
    $(".search-btn").click(function () {
        var searchTerm = $("#search-input")[0].value;
        if (searchTerm != undefined && searchTerm.trim() != "" && searchTerm.trim().length >= minCharCount) {
            $(this).parents(".input-group").next(".error-msg").hide();
            $(this)
                .parents(".input-group")
                .children(".input-group-field")
                .removeAttr("aria-invalid aria-describedby");
            $("#result-info-for-screen-reader").focus();
        } else {
            $(this)
                .parents(".input-group")
                .next(".error-msg")
                .css("display", "block");
            $(this).parents(".input-group").children(".input-group-field").attr({
                "aria-invalid": true,
                "aria-describedby": "searchError-result",
            });
        }
    });
    $("#search-term").keydown(function (e) {
        if (e.which === 13) {
            $(".rmhc-search-btn").click();
        }
    });
    $("#mobile-search-term").keydown(function (e) {
        if (e.which === 13) {
            $(".rmhc-mobile-search-btn").click();
        }
    });
    $("header .search-toggle").click(function () {
        $(this).toggleClass("search-open");
        if ($(this).next().is(":visible")) {
            $(this).next().slideUp();
            $(this).next().attr("aria-hidden", true);
            $(this).attr("aria-expanded", false);
        } else {
            $(this).next().slideDown();
            $(this).next().attr("aria-hidden", false);
            $(this).attr("aria-expanded", true);
            $(this).next().find(".input-group-field").focus();
        }
    });

    $(".closeOverlay, .mob-closeOverlay").click(function (e) {
        //if ($(e.target).closest(".search-dropdown").length === 0) {
            $(".search-dropdown").slideUp();
            $("header .search-toggle").removeClass("search-open");
            $(".search-dropdown").attr("aria-hidden", true);
            $(".search-toggle").attr("aria-expanded", false);
        //}
    });

    //Window click hide dropdown
    $(document).mouseup(function (e) {
        if ($(e.target).closest(".search-dropdown").length === 0) {
            $(".search-dropdown").slideUp();
            $("header .search-toggle").removeClass("search-open");
            $(".search-dropdown").attr("aria-hidden", true);
            $(".search-toggle").attr("aria-expanded", false);
        }
    });
    $("header .search-toggle").keydown(function (e) {
        if (e.keyCode == 27) {
            $(this).next().slideUp();
            $(this).next().attr("aria-hidden", true);
            $(this).attr("aria-expanded", false);
        } else if (e.keyCode == 40) {
            $(this).next().slideDown();
            $(this).next().attr("aria-hidden", false);
            $(this).attr("aria-expanded", true);
            $(this).next().find(".input-group-field").focus();
        }
    });
    $(".close").keydown(function (e) {
        if (e.keyCode == 9) {
            $(".search-dropdown").slideUp();
            $(".search-dropdown").attr("aria-hidden", true);
            $(".search-dropdown").attr("aria-expanded", false);
            $("header .search-toggle").removeClass("search-open");
        }
    });
    $("#mainnav a").focus(function () {
        $(".search-dropdown").slideUp();
        $(".search-dropdown").attr("aria-hidden", true);
        $(".search-dropdown").attr("aria-expanded", false);
        $("header .search-toggle").removeClass("search-open");
    });
    $("#mainnav button").focus(function () {
        $(".search-dropdown").slideUp();
        $(".search-dropdown").attr("aria-hidden", true);
        $(".search-dropdown").attr("aria-expanded", false);
        $("header .search-toggle").removeClass("search-open");
    });
    //search end
    //Email validation for Sign up form start
    function ValidateEmail() {
        var email = document.getElementById("email-address").value;
        var lblError = document.getElementById("email-error");
        var expr = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        if (!expr.test(email)) {
            $(lblError).show();
        } else {
            $(lblError).hide();
        }
    }
    $(".sign-up-form #email-address").focus(function (e) {
        $("#email-error").fadeOut();
    });
    $(".sign-up-form #email-address").keyup(function (e) {
        ValidateEmail();
    });
    $(".sign-up-form").on("blur", "#email-address", function () {
        if ($("#email-error").is(":visible")) {
            setTimeout(function () {
                $("#email-error").fadeOut();
            }, 2000);
        }
    });
    $("#newsletter-form-submit").click(function () {
        ValidateEmail();
        if ($("#email-error").is(":visible")) {
            setTimeout(function () {
                $("#email-error").fadeOut();
            }, 2000);
        }
    });
    //Email validation for Sign up form end

    //For IE image
    var userAgent, ieReg, ie;
    userAgent = window.navigator.userAgent;
    ieReg = /msie|Trident.*rv[ :]*11\./gi;
    ie = ieReg.test(userAgent);
    if (ie) {

        $(".img-container").each(function () {
            var $container = $(this),
                imgUrl = $container.find("img").prop("src");
            if (imgUrl) {
                $(".article-preview .item:first-child").find(".img-container").css("background-size", "contain").css("background-repeat", "no-repeat");
                $container
                    .css("backgroundImage", "url(" + imgUrl + ")")
                    .addClass("custom-object-fit");
            }
        });
    }
    //For Contact Us Page Success Result Focus
    if ($(".ContactUsForm").length) {
        $(".ContactUsForm").on("click", 'input[type="submit"]', function () {
            $("html, body").animate(
                { scrollTop: $(".ContactUsForm").offset().top - 50 },
                500
            );
        });
    }
    //For Accordian
    var accordianTrigger = $(".accordin-block .accordion-title");
    $(accordianTrigger).each(function (i) {
        $(this).attr({
            "aria-expanded": false,
            "aria-controls": "sect-" + (i + 1),
            id: "accordion-" + (i + 1),
        });
    });
    $(".accordion-item .accordion-content").each(function (i) {
        $(this).attr({
            id: "sect-" + (i + 1),
            role: "region",
            "aria-labelledby": "accordion-" + (i + 1),
        });
    });
    $(accordianTrigger).click(function () {
        $(this).parent().toggleClass("is-active");
        var accContent = $(this).next(".accordion-content");
        $(".accordion-content")
            .not(accContent)
            .slideUp()
            .parent(".accordion-item")
            .removeClass("is-active");
        accContent.slideToggle();
        $(accordianTrigger).attr("aria-expanded", false);
        //$(accordianTrigger).removeAttr('aria-disabled');

        if ($(this).parent().hasClass("is-active")) {
            $(this).attr({
                "aria-expanded": true,
                //'aria-disabled':true
            });
        } else {
            $(this).attr("aria-expanded", false);
            $(this).removeAttr("aria-disabled");
        }
    });

    //Accordian KeyDown Event
    $(accordianTrigger).keydown(function (e) {
        if (e.keyCode == 38) {
            e.preventDefault();
            $(this).parent().prev("li").find("button").focus();
        } else if (e.keyCode == 40) {
            e.preventDefault();
            $(this).parent().next("li").find("button").focus();
        } else if (e.keyCode == 27) {
            $(this).parent().toggleClass("is-active");
            var accContent = $(this).next(".accordion-content");
            $(".accordion-content")
                .not(accContent)
                .slideUp()
                .parent(".accordion-item")
                .removeClass("is-active");
            accContent.slideToggle();
            $(accordianTrigger).attr("aria-expanded", false);
            $(accordianTrigger).removeAttr("aria-disabled");

            if ($(this).parent().hasClass("is-active")) {
                $(this).attr({
                    "aria-expanded": true,
                    "aria-disabled": true,
                });
            } else {
                $(this).attr("aria-expanded", false);
                $(this).removeAttr("aria-disabled");
            }
        }
    });
    //Contact Us
    $(".contactUs .button").on("click", function () {
        var captch = false;
        var requiredFiled = 0;
        var containsValue = 0;
        $(".contactUs")
            .find("input")
            .each(function () {
                if (
                    !$(this).hasClass("recaptchaclass") &&
                    $(this)[0].hasAttribute("data-val-required")
                ) {
                    requiredFiled = requiredFiled + 1;
                    if (
                        $(this).attr("class") != undefined &&
                        $(this).attr("class").trim() != "" &&
                        $(this).attr("class").trim() == "valid"
                    ) {
                        containsValue = containsValue + 1;
                    }
                }
            });
        $(".contactUs")
            .find("textarea")
            .each(function () {
                if ($(this)[0].hasAttribute("data-val-required")) {
                    requiredFiled = requiredFiled + 1;
                    if (
                        $(this).attr("class") != undefined &&
                        $(this).attr("class").trim() != "" &&
                        $(this).attr("class").trim() == "valid"
                    ) {
                        containsValue = containsValue + 1;
                    }
                }
            });
        if (
            requiredFiled > 0 &&
            containsValue > 0 &&
            requiredFiled == containsValue
        ) {
            captch = true;
        }
        if (captch == true && $(".recaptchaclass").val().length == 0) {
            grecaptcha.execute();
            return false;
        }
        return true;
    });

    //for Mobile nav accessbility
    $("body").append('<div class="dialog-overlay" tabindex="-1"></div>');
    if ($("nav").length > 0) {
        var navDialogEl = document.querySelector(".top-bar-right");
        var dialogOverlay = document.querySelector(".dialog-overlay");
        var myDialog = new Dialog(navDialogEl, dialogOverlay);
        myDialog.addEventListeners("#nav-icon2", ".close-hamberger");
    }
    if ($(".search-result-filter").length > 0) {
        var navDialogE2 = document.querySelector(".search-result-filter");
        var dialogOverlay1 = document.querySelector(".dialog-overlay");
        var myDialog1 = new Dialog(navDialogE2, dialogOverlay1);
        myDialog1.addEventListeners("#filter button", "#filter-close");
    }
    //Partner Card Keyboard Accessibility
    // Web Accessibility Display  hover-content block on mouseover TECH-1207 / TECH-1300
    $(".partner-card-component").on("mouseover", function (e) {
        e.preventDefault();
        let isPartnerCardChild = $(".partner-card-grid").find(e.target).length;
        $(".partner-card-grid").children(".hover-content").css({ "transition": "opacity 0.05s, visibility s", "opacity": "0", "visibility": "hidden" });
        if (isPartnerCardChild === 1) {
            $(e.target).parents(".partner-card-grid").children(".hover-content").css({ "opacity": "1", "visibility": "visible" });
        } else if (isPartnerCardChild === 0) {
            $(".partner-card-grid").children(".hover-content").css({ "opacity": "0", "visibility": "hidden" });
            $(".partner-card-grid").children(".hover-content").removeClass("hover-content-active");
        }
    });
    // Web Accessibility Display  hover-content block on focus & click TECH-1207 / TECH-1300
    $(".partner-card-grid .img-wrapper a").on("click focus", function () {
        $(".partner-card-grid").children(".hover-content").removeClass("hover-content-active");
        $(this).parents(".partner-card-grid").children(".hover-content").addClass("hover-content-active");
    });
    $(".partner-card-grid").focus(function () {
        $(this).addClass("is-active").siblings().removeClass("is-active");
        $(".partner-card-component").removeClass("focus");
        $(this).parents(".partner-card-component").addClass("focus");
    });
    $(".partner-card-grid").keydown(function (e) {
        if (e.keyCode == 39) {
            $(this).next().focus();
        } else if (e.keyCode == 37) {
            $(this).prev().focus();
        }
    });
    $(".partner-card-component").each(function () {
        $(this)
            .find(".partner-card-grid")
            .last()
            .find("a")
            .focusout(function () {
                $(this).parents(".partner-card-grid").removeClass("is-active");
            });
        $(this)
            .find(".partner-card-grid")
            .last()
            .keydown(function (e) {
                if (e.keyCode == 9) {
                    $(".partner-card-component.focus").removeClass("focus");
                }
            });
    });
    //Partner Card Keyboard Accessibility end
    // Custom Skip To Link Fix
    $("header .skip-link").click(function (e) {
        e.preventDefault();
        $(":header:first").attr("tabindex", "-1").focus();
    });
    //end document ready
    //Start Crypto popup modal.
    const customModal = document.getElementById("cryptoModal");
    const openCustomBtn = document.getElementById("openCryptoModal");
    const closeCustomBtn = document.getElementById("closeCryptoModal");
    const headerSec = document.querySelector("header");
    if (customModal && openCustomBtn && closeCustomBtn) {
        let scrollPosition = 0;
        openCustomBtn.addEventListener("click", () => {
            scrollPosition = window.pageYOffset;
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollPosition}px`;
            document.body.style.width = '100%';
            cryptoModal.style.display = "flex";
            headerSec.style.display = "none";
        });
        closeCustomBtn.addEventListener("click", () => {
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            window.scrollTo(0, scrollPosition);
            cryptoModal.style.display = "none";
            headerSec.style.display = "block";
        });
    }
    //End Crypto popup modal.
});
$.fn.isInViewport = function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};
/* Adding a class to either enable focus styles for keyboard users or remove them for mouse users */
function handleFirstTab(e) {
    if (e.keyCode === 9) {
        document.body.classList.add("keyboard-navigation");
        window.removeEventListener("keydown", handleFirstTab);
        window.addEventListener("mousedown", handleMouseDownOnce);
    }
}
function handleMouseDownOnce() {
    document.body.classList.remove("keyboard-navigation");
    window.removeEventListener("mousedown", handleMouseDownOnce);
    window.addEventListener("keydown", handleFirstTab);
}
window.addEventListener("keydown", handleFirstTab);
//Function for the QueryParam
function getQueryParamValue(queryKey) {
    var queryValue = "";
    var urlParams = new URLSearchParams(location.search);
    for (const [paramKey, paramValue] of urlParams) {
        if (paramKey == queryKey) {
            queryValue = paramValue;
        }
    }
    return queryValue;
}
//Function for merge the URL and link href query param 
function mergeLinkURLQueryParam() {
    $(document).ready(function () {
        const urlParams = new URLSearchParams(window.location.search);
        const pramData = [];
        urlParams.forEach((value, key) => {
            pramData.push({ key: key, value: value });
        });
        const paramsArray = [];
        $('a[href]').each(function () {
            var href = $(this).attr('href');
            if (href.startsWith("/") || href.indexOf(window.location.origin) === 0) {
                if (href.indexOf('?') !== -1) {
                    var orghref = href.split('?')[0];
                    var queryString = href.split('?')[1];
                    var queryParams = queryString.split('&');
                    queryParams.forEach(function (param) {
                        var keyValue = param.split('=');
                        var key = decodeURIComponent(keyValue[0]);
                        var value = decodeURIComponent(keyValue[1]);
                        paramsArray.push({ key: key, value: value });
                    });
                    var mergedParams = [...paramsArray, ...pramData];
                    const mergededData = {};
                    mergedParams.forEach(item => {
                        if (item.key !== "" && item.value !== "undefined") {
                            mergededData[item.key] = item.value;
                        }
                    });
                    const mergedParamsData = Object.entries(mergededData).map(([key, value]) => ({ key, value }));
                    // Convert array to query string
                    updatedData = mergedParamsData.map(item => `${encodeURIComponent(item.key)}=${encodeURIComponent(item.value)}`).join('&');
                    href = orghref + '?' + updatedData;
                } else {
                    href += location.search;
                }
            }
            $(this).attr('href', href);
        });
    });
}

//Family Story Page
var defaulthover, defaultnonhover, text0, text1, text1, text2, text3, noResult;
defaulthover ? defaulthover : "";
defaultnonhover ? defaultnonhover : "";
text0 ? text0 : "";
text1 ? text1 : "";
text2 ? text2 : "";
text3 ? text3 : "";
noResult ? noResult : "No Results!";
function tileColor(targetItems, hovercolor, nonhovercolor) {
    $(targetItems).on("mouseenter", function () {
        $(this).css("background-color", hovercolor);
        $(this).find(".action-container a").css("visibility", "visible");
        $(this).find('.description-content').css('bottom', '0');
    });
    $(targetItems).on("mouseleave", function () {
        $(this).css("background-color", nonhovercolor);
        $(this).find(".action-container a").css("visibility", "hidden");
        $(this).find('.description-content').css('bottom', '-25px');
    });
}
function resultCount(resultCounts, countSelector) {
    if (resultCounts == 1) {
        $(countSelector).text(`${text0} ${resultCounts} ${text2} ${text3}  `)
    } else if (resultCounts > 1) {
        $(countSelector).text(`${text0} ${resultCounts} ${text1}`)
    } else {
        $(countSelector).text(`${noResult}`)
    }
}
function setEqualHeight() {
    var maxHeight = 0;
    $(".family-item .inner-content .description").css("height", "auto");
    $(".family-item .inner-content .description").each(function () {
        var thisHeight = $(this).outerHeight();
        if (thisHeight > maxHeight) {
            maxHeight = thisHeight;
        }
    });
    $(".family-item .inner-content .description").css("height", maxHeight + "px");
}
function setTileEqualHeight() {
    var maxHeight = 0;
    $(".family-item").css("height", "auto");
    $(".family-item").each(function () {
        var thisHeight = $(this).outerHeight();
        if (thisHeight > maxHeight) {
            maxHeight = thisHeight;
        }
    });
    $(".family-item").css("height", maxHeight + "px");
}
function applyHeightAdjustments() {
    setEqualHeight();
    setTileEqualHeight();
}
$(document).ready(function () {
    $(".family-item").css("background-color", defaultnonhover);
    tileColor(".family-item", defaulthover, defaultnonhover);
    var filterValue;
    $('.filter-btn').each(function () {
        filterValue = $(this).data('filter');
        let hovercolorData = $(this).data('hover');
        let nonhovercolorData = $(this).data('nonhover');
        $('.family-card-grid.' + filterValue + ' .family-item').css('background-color', nonhovercolorData);
        var targetItemsValue = $('.family-card-grid.' + filterValue + ' .family-item');
        tileColor(targetItemsValue.selector, hovercolorData, nonhovercolorData);
    });
    var allItems = $(".family-card-grid");
    $('.family-tabs-nav li:first-child .filter-btn').addClass("active");
    var filterCount = allItems.length;
    resultCount(filterCount, ".family-stories-count");
    $(".filter-btn").click(function () {
        $('.family-tabs-nav li .filter-btn').removeClass("active");
        $(this).addClass("active");
        filterValue = $(this).data("filter");
        let hoverValue = $(this).data("hover");
        let nonhoverValue = $(this).data("nonhover");
        filterCount = $(`.${filterValue}`).length;
        if (filterValue === "all") {
            resultCount(allItems.length, ".family-stories-count");
            allItems.show();
            $('.filter-btn').each(function () {
                let allfilterValue = $(this).data('filter');
                let allhovercolor = $(this).data('hover');
                let allnonhovercolor = $(this).data('nonhover');
                if (!$(".family-card-grid").hasClass(allfilterValue)) {
                    $(".family-item").css("background-color", defaultnonhover);
                    tileColor(".family-item", defaulthover, defaultnonhover);
                } else {
                    $('.family-card-grid.' + allfilterValue + ' .family-item').css('background-color', allnonhovercolor);
                    var targetItemsValue = $('.family-card-grid.' + allfilterValue + ' .family-item');
                    tileColor(targetItemsValue.selector, allhovercolor, allnonhovercolor);
                }
            });
        } else {
            resultCount(filterCount, ".family-stories-count");
            allItems.hide();
            allItems.filter("." + filterValue).show();
            $(".family-item").css("background-color", nonhoverValue);
            tileColor(".family-item", hoverValue, nonhoverValue);
        }
    });
    // Run on page load
    applyHeightAdjustments();
    $('.description-content>h3').css({
        'display': '-webkit-box',
        '-webkit-line-clamp': '2',
        '-webkit-box-orient': 'vertical',
        'overflow': 'hidden'
    });
    $('.img-title-container').css({
        'display': '-webkit-box',
        '-webkit-line-clamp': '4',
        '-webkit-box-orient': 'vertical',
        'overflow': 'hidden'
    });
    // Re-run on window resize
    $(window).on("resize", function () {
        applyHeightAdjustments();
    });

    /* --- Optimized Tab Persistence --- */

    // 1. Update Hash on Click
    $('.filter-btn').on('click', function () {
        history.replaceState(null, null, "#" + $(this).data('filter'));
    });

    // 2. Restore Tab on Page Load (Back Button)
    var hash = window.location.hash.replace('#', '');
    if (hash && hash !== 'all') {
        setTimeout(function () {
            var $btn = $('.filter-btn[data-filter="' + hash + '"]');
            if ($btn.length) {
                $('.filter-btn').removeClass("active"); // Clear "All"
                $btn.addClass("active").trigger('click');
            }
        }, 150); // 150ms is enough to override the default "All"
    }

});

//overview block animation js starts
window.addEventListener('load', function () {
    const sections = document.querySelectorAll('.overview-block-component');
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const statCounters = entry.target.querySelectorAll('.js-stat-counter');
            if (entry.isIntersecting) {
                // --- START ANIMATION ---
                statCounters.forEach(counter => {
                    const originalText = counter.getAttribute('data-target');
                    const target = parseFloat(originalText.replace(/,/g, ''));
                    if (isNaN(target)) return;

                    let currentVal = 0;
                    const duration = 2000;
                    const interval = 10;
                    const increment = target / (duration / interval);

                    // Stop any previous animation to prevent overlapping
                    if (counter.timer) clearInterval(counter.timer);

                    counter.timer = setInterval(() => {
                        currentVal += increment;
                        if (currentVal >= target) {
                            counter.innerText = originalText;
                            clearInterval(counter.timer);
                        } else {
                            let displayVal = (target % 1 !== 0)
                                ? currentVal.toFixed(1)
                                : Math.floor(currentVal);
                            counter.innerText = Number(displayVal).toLocaleString();
                        }
                    }, interval);
                });
            } else {
                // --- RESET TO 0 WHEN SCROLLED AWAY ---
                statCounters.forEach(counter => {
                    if (counter.timer) clearInterval(counter.timer);
                    counter.innerText = "0"; // This allows it to "restart" next time
                });
            }
        });
    }, { threshold: 0.1 }); // Starts as soon as 10% of the section is visible
    sections.forEach(section => observer.observe(section));
});
//overview block animation js ends here
// search page js // Search Clear Button
document.addEventListener("DOMContentLoaded", function () {
    const searchInput = document.querySelector(".search-outer .page-search-input");
    const removeBtn = document.querySelector(".remove-search");
    if (!searchInput || !removeBtn) return;
    function toggleRemoveButton() {
        if (searchInput.value.trim() !== "") {
            removeBtn.classList.add("visible");
        } else {
            removeBtn.classList.remove("visible");
        }
    }
    removeBtn.addEventListener("click", function () {
        searchInput.value = "";
        toggleRemoveButton();
        searchInput.focus();
    });
    searchInput.addEventListener("input", toggleRemoveButton);
    toggleRemoveButton();
});
function getQueryParam(name) {
    const urlParams = new URLSearchParams(window.location.search);//+ window.location.hash
    return urlParams.get(name);
}
function validateInput(value, maxLength, errorMessage, errorMessageLength, pasteError, minLengthError, searchValMessage) {
    let error = '';
    let minCharLength = 3;

    if (!allowedRegexsearch.test(value)) {
        error = errorMessage;
    } else if (value.length >= maxLength) {
        error = errorMessageLength;
    } else if (value.length < minCharLength) {
        error = minLengthError;
    } else if (value.trim().length === 0 && value.length > 0) {
        error = searchValMessage;
    }
    if (error) {
        isvalidationMsg.style.display = 'block';
        isvalidationMsg.textContent = error;
    } else {
        isvalidationMsg.style.display = 'none';
        isvalidationMsg.textContent = '';
    }
}
document.addEventListener("DOMContentLoaded", function () {
    const searchInput = document.querySelector(".search-box-outer .page-search-box-input");
    const removeBtn = document.querySelector(".remove-search-box");
    if (!searchInput || !removeBtn) return;
    function toggleRemoveButton() {
        if (searchInput.value.trim() !== "") {
            removeBtn.classList.add("visible");
        } else {
            removeBtn.classList.remove("visible");
        }
    }
    removeBtn.addEventListener("click", function () {
        searchInput.value = "";
        toggleRemoveButton();
        searchInput.focus();
    });
    searchInput.addEventListener("input", toggleRemoveButton);
    toggleRemoveButton();
});
document.addEventListener("DOMContentLoaded", function () {
    const searchInput = document.querySelector(".search-mob-outer .page-search-mob-input");
    const removeBtn = document.querySelector(".remove-search-mob");
    if (!searchInput || !removeBtn) return;
    function toggleRemoveButton() {
        if (searchInput.value.trim() !== "") {
            removeBtn.classList.add("visible");
        } else {
            removeBtn.classList.remove("visible");
        }
    }
    removeBtn.addEventListener("click", function () {
        searchInput.value = "";
        toggleRemoveButton();
        searchInput.focus();
    });
    searchInput.addEventListener("input", toggleRemoveButton);
    toggleRemoveButton();
});

// generic function for lightbox append url

function appendUrlParameters(buttonSelector) {

    const donateLinks = document.querySelectorAll(buttonSelector);

    if (donateLinks.length > 0) {

        const defaultURLValue = window.appConfig.defaultURLValue;
        const pageParams = new URLSearchParams(window.location.search);
        const shouldAppendParams = window.appConfig.passSourceCode;

        donateLinks.forEach(function (donateLink) {
            const linkUrl = new URL(donateLink.href);

            if (shouldAppendParams && pageParams.size == 0) {

                const defaultParams = new URLSearchParams(defaultURLValue);

                defaultParams.forEach((value, key) => {
                    linkUrl.searchParams.set(key, value);
                });

                donateLink.href = linkUrl.toString();

            } else {

                var entries = Array.from(pageParams.entries());
                var i = 0;

                while (i !== entries.length) {
                    var key = entries[i][0];
                    var value = entries[i][1];
                    linkUrl.searchParams.set(key, value);
                    i = i + 1;
                }

                donateLink.href = linkUrl.toString();
            }
        });
    }
}
// appendUrlParameters function calling
document.addEventListener('DOMContentLoaded', function () {
    appendUrlParameters('.generic-appned-url');
});
// show and disable lightbox functionality moved here..
$(document).ready(function () {
    var showLightBoxCooki = getCookieValue('displayLightBoxModal');
    
    if (showLightBoxCooki == null || showLightBoxCooki == '' || showLightBoxCooki != 'false' && globalLightBoxActive == 'True') {
        var pageParams = new URLSearchParams(window.location.search);
        var srcValue = pageParams.get('src');

        if (srcValue && srcValue.toLowerCase() === 'email') {
            return;
        }

        if (enableLightboxPageLevel == 'True' && globalLightBoxActive == 'True') {
            var popup = new Foundation.Reveal($('#lightboxModal'));
            popup.open();
            setExpirationCookie('displayLightBoxModal', 'false', 1);
        }
        
       
    }
});
function CloseLightBox() {
    setExpirationCookie('displayLightBoxModal', 'false', 1);
}
function getCookieValue(cname) {
    var name = cname + "=";  
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1);
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
function setExpirationCookie(name, value, exp) {
    var cookie = name + "=" + value + ";";
    var exp = getCookieExpiryDT(cookie, exp);
    document.cookie = cookie + exp + "; path=/;";
}
function getCookieExpiryDT(cvalue, exdays) {
    var d = new Date();
    if (exdays > 0) {
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    }
    var expires = "expires=" + d.toGMTString();
    return expires;
}